import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config';

function Login() {
  const [formData, setFormData] = useState({ login: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [recoverEmail, setRecoverEmail] = useState('');
  const [recoverMessage, setRecoverMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.email) {
      setFormData((prev) => ({ ...prev, login: location.state.email }));
    }
  }, [location.state]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.login) newErrors.login = 'Por favor, insira seu nome de usuário ou e-mail';
    if (!formData.password) newErrors.password = 'A senha é obrigatória';
    return newErrors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setErrors({});
    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/wp-json/palpitex/v1/login`, {
        username: formData.login,
        password: formData.password,
      });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userRole', response.data.role);
      localStorage.setItem('userFoto', response.data.foto);
      localStorage.setItem('userCpf', response.data.cpf);
      localStorage.setItem('userNome', response.data.nome);
      localStorage.setItem('userApelido', response.data.apelido);
      localStorage.setItem('userTelefone', response.data.telefone);
      navigate('/campeonatos');
    } catch (error) {
      setErrors({ general: error.response?.data?.message || 'Erro ao fazer login. Verifique suas credenciais.' });
    } finally {
      setLoading(false);
    }
  };

  const handleRecoverPassword = async (e) => {
    e.preventDefault();
    if (!recoverEmail || !/\S+@\S+\.\S+/.test(recoverEmail)) {
      setRecoverMessage('Por favor, insira um e-mail válido.');
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/wp-json/palpitex/v1/recover-password`, {
        email: recoverEmail,
      });
      setRecoverMessage(response.data.message);
      setTimeout(() => {
        setShowRecoverModal(false);
        setRecoverEmail('');
        setRecoverMessage('');
      }, 3000);
    } catch (error) {
      setRecoverMessage(error.response?.data?.message || 'Erro ao enviar solicitação de recuperação.');
    }
  };

  return (
    <div className="form-container">
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            name="login"
            placeholder="Nome de usuário ou e-mail"
            value={formData.login}
            onChange={handleChange}
          />
          {errors.login && <p className="error">{errors.login}</p>}
        </div>
        <div>
          <input
            type="password"
            name="password"
            placeholder="Senha"
            value={formData.password}
            onChange={handleChange}
          />
          {errors.password && <p className="error">{errors.password}</p>}
        </div>
        {errors.general && <p className="error">{errors.general}</p>}
        <button type="submit" disabled={loading}>
          {loading ? 'Carregando...' : 'Entrar'}
        </button>
      </form>
      <p>
        Ainda não tem conta? <a href="/register">Cadastre-se</a>
      </p>
      <p>
        <a href="#!" onClick={() => setShowRecoverModal(true)}>
          Esqueceu sua senha?
        </a>
      </p>

      {showRecoverModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Recuperar Senha</h3>
            <form onSubmit={handleRecoverPassword}>
              <div>
                <input
                  type="email"
                  placeholder="Digite seu e-mail"
                  value={recoverEmail}
                  onChange={(e) => setRecoverEmail(e.target.value)}
                />
              </div>
              {recoverMessage && <p className={recoverMessage.includes('Erro') ? 'error' : 'success'}>{recoverMessage}</p>}
              <button type="submit">Enviar</button>
              <button type="button" onClick={() => setShowRecoverModal(false)}>
                Fechar
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;